import { useState } from "react";
import { RouteState } from "@circuitry-ai/doc-data";
import { AuditLogsAgGridWrapper, AGENT_AUDIT_LOG_STATIC_FILTERS, CustomTabs, PageHeader } from "@circuitry-ai/doc-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AgentViewTabs } from "./agentview";
import AgentsList from "./agentslist";

export interface AgentpageProps { }

export function AgentsPage(props: AgentpageProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState('agents');

    return (
        <div className='flex flex-col h-full min-h-0'>
            <PageHeader
                heading="Agents"
                description={'View all your Agents at one place.'}
                showCreateButton={selectedTab === 'agents'}
                createButtonText={'Create Agent'}
                entityType="agent"
                onCreateButtonClick={() => navigate(`/agents/${RouteState.CREATE}?tab=${AgentViewTabs.DEFINITION}`)}
            />
            <div className="pb-2">
            <CustomTabs
                tabs={[
                    { key: 'agents', title: t('Agents'), id: 'agents-tab' },
                    { key: 'audit-logs', title: t('Audit Logs'), id: 'agents-audit-logs-tab' },
                ]}
                selectedKey={selectedTab}
                onTabChange={setSelectedTab}
            />
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto">
                {selectedTab === 'agents' && <AgentsList />}
                {selectedTab === 'audit-logs' && (
                        <AuditLogsAgGridWrapper staticFilters={AGENT_AUDIT_LOG_STATIC_FILTERS} />
                )}
            </div>
        </div>
    );
}


export default AgentsPage;
